import script from "./DragDropGame.vue?vue&type=script&setup=true&lang=js"
export * from "./DragDropGame.vue?vue&type=script&setup=true&lang=js"

import "./DragDropGame.vue?vue&type=style&index=0&id=52902421&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52902421"]])

export default __exports__